import angular from 'angular';

import FiltroBuscarService from './buscador.service';
import FiltroBuscarFactory from './buscar.factory';
import UtilFactory from './util.factory';


const MODULE_NAME = 'buscador.servicios';

const ngModule=angular.module(MODULE_NAME, []);


ngModule.service('buscadorService', FiltroBuscarService)
            .service('utilFactory',  UtilFactory)
            .service('filtroBuscarFactory', FiltroBuscarFactory);

export default MODULE_NAME;


// WEBPACK FOOTER //
// ./src/busqueda/servicios/index.js